import './en';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// c:/Projects/CCLibrary/Client/~/ngx-bootstrap/bs-moment/locale/index.js
// module id = ../../../../ngx-bootstrap/bs-moment/locale/index.js
// module chunks = 4